import dayjs from "dayjs"
import { useMemo } from "react"
import { useGraphContext } from "../GraphContext"

export function useItemStartAndStopTime(index: number) {
  const {
    graphStart,
    numberOfItems,
    hoursPerGraphItem,
  } = useGraphContext()

  // the earliest time in this list item
  const itemStartTime: string = useMemo(
    () => dayjs(graphStart)
      .add(
        (numberOfItems - index - 2) * hoursPerGraphItem,
        "hours",
      )
      .toISOString(),
    [
      graphStart,
      numberOfItems,
      hoursPerGraphItem,
      index,
    ],
  )

  // the latest time in this list item
  const itemStopTime: string = useMemo(
    () => dayjs(itemStartTime).add(
      hoursPerGraphItem,
      "hours",
    )
      .toISOString(),
    [
      itemStartTime,
      hoursPerGraphItem,
    ],
  )

  return useMemo(
    () => [
      itemStartTime,
      itemStopTime,
    ],
    [
      itemStartTime,
      itemStopTime,
    ],
  )
}
